<div #canvascontainer style="width: 100%;">
    <canvas id="sheet" #drawcanvas height="200"></canvas>
    <button mat-raised-button color="warn" (click)="clear()" style="margin: 28px 8px; width: 48%; height: 48px;"><mat-icon>clear</mat-icon></button>    
</div>


